import isEmpty from 'lodash/isEmpty';
import {
  ReactNode, useEffect, useState,
} from 'react';
import {
  FormGroup, Input, Label, InputProps,
  FormFeedback,
} from 'reactstrap';

export interface RadioInputProps extends InputProps {
  label?: string | ReactNode
  name?: string
  id?: string
  type: 'radio'
  checked?: boolean
  labelClassName?: string
  fieldError?: string
  isReadOnly?: boolean
  onInputChangeHandler?: (value: boolean) => void
}

// eslint-disable-next-line react/display-name
const RadioInput = (({
  label = '', name = '', id, type, checked = false, onInputChangeHandler = () => {},
  isReadOnly = false, labelClassName = '', fieldError = '', ...props
}: RadioInputProps) => {
  const [ error, setError ] = useState(fieldError);

  useEffect(() => {
    if (!isEmpty(fieldError) && fieldError !== error) {
      setError(fieldError);
      return;
    }
    setError('');
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ fieldError ]);

  return (
    <FormGroup
      check
      className="form-group"
      style={{ display: 'flex', alignItems: 'center' }}
    >
      <Input
        {...props}
        id={id}
        name={name}
        type={type}
        className="custom-radio-input"
        checked={checked}
        onChange={(e: any) => onInputChangeHandler(e)}
        invalid={!isEmpty(error)}
        disabled={isReadOnly}
      />
      {label && (
        <Label check className={labelClassName}>
          {label}
        </Label>
      )}
      <FormFeedback>{error}</FormFeedback>
    </FormGroup>
  );
});

export default RadioInput;
